import React from "react";
import { BodyText } from "../../../styles/global";
import { StoryCardProps } from "../../../interfaces/interfaces.d";
import { StoryCardWrapper } from "./Storycards.styles";

export const StoryCard: React.FC<StoryCardProps> = ({
  title,
  text,
}: StoryCardProps) => {
  return (
    <>
      <StoryCardWrapper>
          <div>
            <h1>{title}</h1>
            <BodyText style={{ textAlign: "justify" }}>{text}</BodyText>
          </div>
      </StoryCardWrapper>
    </>
  );
};
